export default {
  name: 'mall',
  path: '/mall',
  component: () => import('@/views/mall'),
  children: [
    {
      name: 'mall-category', // 首页
      path: '',
      component: () => import('@/views/mall/categories')
    },
    {
      name: 'mall-result', // 搜索页
      path: 'result',
      component: () => import('@/views/mall/result')
    },
    {
      name: 'mall-search',
      path: 'search',
      component: () => import('@/views/mall/search')
    },
    {
      name: 'mall-detail', // 商品详情
      path: 'detail',
      component: () => import('@/views/mall/detail')
    },
    {
      name: 'mall-store-info', // 店铺信息，现在还没做首页
      path: 'storeInfo',
      component: () => import('@/views/mall/store/info.vue')
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/routes/mall.js